<template>
  <v-container fluid >
    <v-row dense  style="height: 50px">
      <v-col md="auto">
        <v-btn
          rounded
          small
          fab
          color="primary"
          class="add-button-fab mb-2"
          @click.stop="addUserForm()"S
          >
          <v-icon small>mdi-plus-thick</v-icon>
        </v-btn>
      </v-col>
      <!-- View Title -->
      <v-col >
        <ViewTitle title="Users" />
      </v-col>
      <v-col cols="2">
        <AutocompleteSelect
          v-if="!isAdmin"
          :props="autocomplete_filter"
          @update="update_filter"
        />
      </v-col>
      <v-col
      class="d-flex justify-end mb-0 pb-0 component"
      md="auto"
      >
        <SearchTextAdmin @input="setSearchText" 
        @output="setSearchText"/>
      </v-col>
    </v-row>
    <v-data-table
      fixed
      small
      :items="filtered_users"
      :headers="isAdmin ? fields.filter(it => it.value != 'roles') : fields.filter(it => (['username','id','isAdmin'].indexOf(it.value)) < 0)"
      dense
      item-class="qmkey-item-row"
      sort-by="last_name"
      show-expand
      :search="search"
    >
      <!-- <template v-slot:[`item.username`]="{ item }">
        <v-btn
          @click.stop="editUserForm(item.id)"
          text
          small
          class="qmkey-add-button-menu"
        >
          {{ item.username }}
        </v-btn>
      </template> -->
      <template v-slot:item.isAdmin="{item}">
        <b v-if="item.isAdmin" class="text-success">✔</b>
      </template>
      <template v-slot:item.isManager="{item}">
        <b v-if="item.isManager" class="text-success">✔</b>
      </template>
      <template v-slot:item.support_level="{item}">
        <b v-if="item.support_level.chat" class="text-success">✔</b>
      </template>
      <template v-slot:item.roles="{item, index}">
        <v-menu
          v-if="item.roles.length > 1"
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{on}">
            <span class="d-flex" v-on="on">
              <ChipList
                :item="{items: [item.roles[0]]}"
              />
              <div class="text-caption">{{"(+" + (item.roles.length - 1) + ")"}} </div>
            </span>
          </template>
          <div class="white pa-2 user-role-column"  style="">
            <ChipList
              :item="{items: item.roles || []}"
            />
          </div>
        </v-menu>
        <ChipList v-else-if="item.roles.length > 0"
          :item="{items: item.roles || []}"
        />
      </template>
      <template v-slot:item.is_active="{item}">
        <b v-if="item.is_active" class="text-success">✔</b>
      </template>
      <template v-slot:item.email_notifications="{item}">
        <b v-if="item.email_notifications" class="text-success">✔</b>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          v-if="isAdmin"
          small
          class="mr-2"
          @click.stop="editUserForm(item)"
          :disabled=!isAdmin
        >
          mdi-pencil
        </v-icon>
        <ActionTransitions
          v-else
          :disabled="item.isAdmin"
          :unit="user_actions(item,allRoles)"
          @transition="(transit) => open_transition_modal(item,transit)"
        />
        <v-icon
          v-if="isAdmin"
          small
          icon
          class="mr-2"
          @click.stop="deleteUserForm(item)"
          :disabled=!isAdmin
        >
          mdi-trash-can-outline
        </v-icon>
      </template>

      <!-- Expanded -->
      
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="fields.length +1"
          class="qmkey-explorer-table-expansion-td"
        > <!-- needed to use row length -->
          <v-container fluid>
            <v-row class="qmkey-explorer-table-expansion-cont">
              <v-tabs
                v-model="tabs"
                icons-and-text
                align-with-title
                background-color="#cac8c9"
                height = 32
                class="qmkey-explorer-table-expansion-panel"
                active-class="qmkey-explorer-table-expansion-panel-active"
              >
                <v-tabs-slider style="display: none"></v-tabs-slider>
                <v-tab class="qmkey-explorer-table-expansion-panel-header">
                  <div class="tab">User</div>
                </v-tab>
              </v-tabs>
              <v-tabs-items 
                v-model="tabs"
                class="qmkey-explorer-table-expansion-panel-contents"
              >
                <v-tab-item
                  class="qmkey-explorer-table-expansion-panel-content"
                >
                  <!-- Site data -->
                  <v-container fluid>
                    <v-row align="end" class="white data-inline-content">
                      <v-col cols="6">
                        <span class="data-inline-header-content-reference">
                          #{{ item.id }}
                        </span>
                        <span class="pl-1 data-inline-header-content-title">
                          {{ item.username }}
                        </span>
                      </v-col>
                    </v-row>
                      <span class="data-inline-expand-title"></span>
                      <v-row>
                        <v-col v-if="isAdmin">
                          <div>
                            <span class="data-inline-data-title"> Username </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.username">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Name </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.first_name">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Last name </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.last_name">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Email </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.email">                    
                            </div>
                          </div>
                        </v-col>
                        <!-- Column for manager to maintain the structure -->
                        <v-col v-if="!isAdmin"></v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Manager </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.isManager?'True':'False'">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Admin </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.isAdmin?'True':'False'">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Support chat </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.support_level.chat?'True':'False'">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <!-- should we change this to show "email / internal / both / none" in single column?
                                 for now table is too cluttered, internal_notifications values won't be shown -->
                            <span class="data-inline-data-title"> Email notifications </span>
                            <div :class="['data-inline-data', 'text-justify']"
                                  v-html="item.email_notifications?'True':'False'">
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Roles </span>
                            <div :class="['data-inline-data', 'text-justify']">
                              <ChipList
                                :item="{items: item.roles || []}"
                              />
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Enabled </span>
                            <div :class="['data-inline-data', 'text-justify']"
                                  v-html="item.is_active?'True':'False'">
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Languaje </span>
                            <div :class="['data-inline-data', 'text-justify']" 
                                  v-html="item.lang">
                            </div>
                          </div>
                        </v-col>
                        <!-- Just to mantain format -->
                        <v-col></v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="data-inline-data-title"> Preferred Centro </span>
                          <div :class="['data-inline-data', 'text-justify']" 
                                v-html="item.preferred_centro_name">                    
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Photo </span>
                            <div :class="['data-inline-data', 'text-justify']">
                              <v-img
                                max-width="100px"
                                :src="getPhoto(item)"
                                contain
                              />
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-tab-item>                
              </v-tabs-items>
            </v-row>
          </v-container>
        </td>
      </template>

    </v-data-table>
    <!-- Add / Edit / Delete User Modal -->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      validate
      @close-dialog="toggle_dialog"
      @submit="submit_action"
    >
    </modal-dialog-form>
  </v-container>

</template>

<style lang="scss">
.user-role-column {
  max-width: 200px;
  width: 100%;
}
</style>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import ViewTitle from '@/components/ViewTitle'
import ModalDialogForm from '@/components/explorer/ModalDialog'
// TODO. Move that to API methods
import User from '@/api/User'
import Roles from '@/api/Roles'
import QCentro from '@/api/QCentro'
import SearchTextAdmin from '@/components/header/SearchTextAdmin'
import ActionTransitions from '@/components/explorer/actions/ActionTransitions'
import GenericTreeviewSelect from '@/components/inputs/GenericTreeviewSelect'
import ChipList from '@/components/explorer/chips/ChipList';
import AutocompleteSelect from '@/components/inputs/AutocompleteSelect'

export default {
  name: 'UsersView',
  components: {
    ViewTitle,
    ModalDialogForm,
    SearchTextAdmin,
    ActionTransitions,
    GenericTreeviewSelect,
    ChipList,
    AutocompleteSelect,
  },

  data: function() {
    return {
      currentEditUser: { roles: [], support_level: {} }, // <b-form-select> needs a list
      allRoles: [],
      fields: [
        { value: 'username', text: 'Username', sortable: true},
        { value: 'first_name', text: 'Name', sortable: true },
        { value: 'last_name', text: 'Last Name', sortable: true },
        { value: 'email', text: 'Email' },
        { value: 'is_active', text: 'Enabled' },
        { value: 'email_notifications', text: 'Email notifs'},
        { value: 'isAdmin', text: 'Admin' },
        { value: 'isManager', text: 'Manager'},
        { value: 'support_level', text: 'Support Chat'},
        { value: 'roles', text: 'Roles', sortable: false}, // Just for managers
        { value: 'site_name', text: 'Site', sortable: true},
        { value: 'id', text: 'Id', sortable: true},
        { value: 'actions', text:'', sortable:false },
        { value: 'data-table-expand', text: '', sortable: false, filterable: false,
        },
      ],
      new_user: true,
      photo_url:'',
      photo: null,
      search:'',
      tabs: null,
      modal_title: '',
      showModalDialog: false,
      fields_to_collect: [],
      submit_button_caption: 'Save', // Harcoded text
      submit_action: function () {},
      selected_roles: [],
    }
  },

  computed: {
    ...mapState(['isLoading', 'users', 'site_centros']),
    ...mapGetters(['isAdmin', 'sitePath', 'user', 'site_id', 'centro_id']),
    centros() {
       return this.site_centros[this.site_id];
     },
    filtered_users_by_admin() {
      if (this.isAdmin) {
        return this.users;
      } else {
        return this.users.filter(usr => usr.site == this.site_id)
      }
    },
    user_with_roles() {
      return this.filtered_users_by_admin.map(user => ({...user,'roles': this.getRolesFromUser(user.id)}));
    },

    filtered_users() {
      if (this.selected_roles && this.selected_roles.length > 0) {
        return this.user_with_roles.filter(it => it.roles.findIndex(rol => this.selected_roles.includes(rol.value)) >= 0);
      } else {
        return this.user_with_roles;
      }
    },

    autocomplete_filter() {
      return {
        cols: 2,
        component: "AutocompleteSelect",
        disabled: false,
        hidden: this.isAdmin,
        id: "business_process_include",
        items: this.allRoles.map(it => ([it.id,it.name])),
        label: "Selecciona rol",
        multiple: true,
        value: this.selected_roles,
        chips: true,
      }
    },
  },

  mounted: function() {
    /* this.SET_CURRENT_SITE(this.$session.get('site')) */ // TODO: Remove this line?
    this.GET_USERS(this.sitePath)
    this.getRoles()
  },

  methods: {
    ...mapActions({GET_USERS:'GET_USERS',set_user:'UserSession/set_user'}),
    ...mapMutations(['SET_CURRENT_SITE']),
    getRoleFromId(role){
      if(this.allRoles.length>0){
        return this.allRoles.find((v)=>v.value==role)?this.allRoles.find((v)=>v.value==role).text:''
      }else{
        return ''
      }
    },
    getRolesFromUser(user){
      return (this.allRoles || []).filter((v)=>v.users.includes(user)).map(itm => ({
        component: 'ChipGeneric',
        name: 'legend_'+itm.name,
        readable: itm.name,
        value: itm.id,
        readableValue: itm.name,
        hide_icon: true,
        hide_text: true,
      }));
    },
    update_filter(roles) {
      this.selected_roles = roles;
    },
    get_fields(){
      let value_id=null
      let value_username=null
      let value_password=null
      let value_email=null
      let value_first_name=null
      let value_last_name=null
      let value_roles=[]
      let value_manager='false'
      let value_admin='false'
      let value_support_chat='false'
      let value_photo=null
      let value_is_active='true'
      let value_email_notifications='true'
      let value_internal_notifications='true'
      let value_lang='es'
      let value_preferred_centro=null;
      if(this.currentEditUser){
        value_username=this.currentEditUser.username
        value_password=this.currentEditUser.password
        value_email=this.currentEditUser.email
        value_first_name=this.currentEditUser.first_name
        value_last_name=this.currentEditUser.last_name
        value_roles=this.currentEditUser.roles
        value_manager=this.currentEditUser.isManager.toString()
        value_admin=this.currentEditUser.isAdmin.toString()
        value_support_chat=this.currentEditUser.support_level.chat.toString()
        value_photo=null
        value_is_active=this.currentEditUser.is_active.toString()
        value_email_notifications=this.currentEditUser.email_notifications.toString()
        value_internal_notifications=this.currentEditUser.internal_notifications.toString()
        value_lang=this.currentEditUser.lang
        value_preferred_centro=this.currentEditUser.preferred_centro;
      }
      return [
        [
          {
            id: 'username',
            label: 'Username',
            required: true,
            value: value_username,
            readonly: !this.isAdmin,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter username',
          },
          {
            id: 'password',
            label: 'Password',
            required: this.new_user,
            value: value_password,
            is_password: true,
            readonly: !this.isAdmin,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter password',
          },
          {
            id: 'email',
            label: 'Email',
            required: true,
            value: value_email,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter email',
            is_email: true,
          },
        ],
        [
        {
            id: 'first_name',
            label: 'Name',
            required: true,
            value: value_first_name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter name',
          },
          {
            id: 'last_name',
            label: 'Last name',
            required: true,
            value: value_last_name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter last name',
          },
          {
            id: 'lang',
            label: 'Languaje',
            required: true,
            value: value_lang,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['es','Spanish'],['ca','Catalan'], ['en','English']],
          },
        ],
        [
          {
            id: 'is_active',
            label: 'Enabled',
            required: true,
            value: value_is_active,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['false','False'],['true','True']],
          },
          {
            id: 'email_notifications',
            label: 'Send notification emails',
            required: true,
            value: value_email_notifications,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['false','False'],['true','True']],
          },
          {
            id: 'internal_notifications',
            label: 'Send internal notifications',
            required: true,
            value: value_internal_notifications,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['false','False'],['true','True']],
          },
        ],
        [
          {
            id: 'isManager',
            label: 'Manager',
            required: true,
            value: value_manager,
            readonly: !this.isAdmin,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['false','False'],['true','True']],
          },
          {
            id: 'isAdmin',
            label: 'Admin',
            required: true,
            value: value_admin,
            readonly: !this.isAdmin,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['false','False'],['true','True']],
          },
          {
            id: 'chat',
            label: 'Support chat',
            required: true,
            value: value_support_chat,
            readonly: !this.isAdmin,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['false','False'],['true','True']],

          },
        ],
        [
        // {
        //     id: 'roles',
        //     label: 'Roles',
        //     required: false,
        //     value: value_roles,
        //     readonly: false,
        //     hidden: null,
        //     cols: 4,
        //     class: null,
        //     component: 'Select',
        //     placeholder: 'Choose user roles',
        //     items: this.allRoles.map((val) => [val.value, val.text]),
        //     multiple: true,
        //   },
        {
            id: 'preferred_centro',
            label: 'Preferred Centro',
            required: false,
            value: value_preferred_centro,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'AutocompleteSelect',
            placeholder: 'Choose user preferred centro',
            items: this.get_user_centros(this.currentEditUser).map((val) => [val.id, val.name]),
            multiple: false,
          },
        ],
        [
          {
            id: 'photo',
            label: 'Photo',
            required: false,
            value: value_photo,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          },
        ],
        [
          {
            id: 'warning1',
            label: "Remember that user roles are managed in the centers space",
            required: false,
            value: "",
            readonly: true,
            hidden: null,
            cols: 4,
            class: 'warning',
            component: 'Tag',
            placeholder: '',
          },
        ]
      ] 
    },
    addUserForm() {
      this.new_user=true
      this.currentEditUser = {
        roles: [],
        is_active:'true',
        email_notifications:'true',
        internal_notifications:'true',
        isManager:'false',
        isAdmin:'false',
        support_level:{chat:'false'},
        site:this.site_id,
      }
      this.modal_title = `Add new user`
      const preferred_centro_items = this.get_user_centros(this.currentEditUser).map((val) => [val.id, val.name]);
      const manager_fields = User.get_creation_fields(this.user,{"preferred_centro_items": preferred_centro_items});
      this.fields_to_collect = this.isAdmin ? this.get_fields() : manager_fields;
      this.showModalDialog = true
      this.submit_action = this.addUser
      this.submit_button_caption = 'Save'
    },
    editUserForm(item) {
      this.new_user=false
      this.currentEditUser = item
      this.modal_title = `Edit user #${item.id}`
      this.fields_to_collect = this.get_fields()
      this.showModalDialog = true
      this.submit_action = this.updateUser
      this.submit_button_caption = 'Save'
    },
    deleteUserForm(item) {
      this.currentEditUser = item
      this.modal_title = `Delete user #${item.id} ${item.username}`
      this.fields_to_collect = []
      this.showModalDialog = true
      this.submit_action = this.deleteUser
      this.submit_button_caption = 'Delete'
    },
    addUser(formdata) {
      let support_level={chat:JSON.parse(formdata.get("chat"))}
      formdata.delete("chat")
      formdata.append("support_level",JSON.stringify(support_level))
      //If not changed img, it stays as string, in change, it's a file. Check it's a file to send
      if(typeof(formdata.get('photo'))!="object") formdata.delete('photo')
      User.postUser(this.sitePath, formdata)
        .then(() => {
          this.GET_USERS(this.sitePath)
          this.showModalDialog=false
          this.currentEditUser={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    deleteUser() {
      User.delete(this.sitePath, this.currentEditUser.id)
        .then(() => {
          this.GET_USERS(this.sitePath)
          this.showModalDialog=false
          this.currentEditUser={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    updateUser(formdata) {
      let support_level={chat:JSON.parse(formdata.get("chat"))}
      formdata.delete("chat")
      formdata.append("support_level",JSON.stringify(support_level))
      //If not changed img, it stays as string, in change, it's a file. Check it's a file to send
      if(typeof(formdata.get('photo'))!="object") formdata.delete('photo')
      formdata.append("id",this.currentEditUser.id)
      formdata.append("site",this.currentEditUser.site)
      formdata.append("site_name",this.currentEditUser.site_name)
      User.putUser(this.sitePath, this.currentEditUser.id, formdata)
        .then(() => {
          this.GET_USERS(this.sitePath)
          this.showModalDialog=false
          if (this.currentEditUser.id == this.user.id) {
            this.set_user(this.currentEditUser);
            this.$vuetify.lang.current = this.currentEditUser.lang;
          }
          this.currentEditUser={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    getRoles() {
      QCentro.centro_roles(this.site_id, this.centro_id)
        .then(response => {
          this.allRoles = []
          for (var role of Object.values(response)) {
            this.allRoles.push({...role, value: role.id, text: role.name })
          }
          this.checkInheritRoles()
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkInheritRoles() {
      Roles.listInheritance(this.sitePath)
        .then((response) => {
          let inheritRoles = response.map(v => ({text: v.name, value: v.id}));
          for(const i of inheritRoles){
            if (this.allRoles.some(v => v.value == i.value)) {
              this.allRoles.find(v => v.value == i.value).text = ' - '+i.text
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
    },
    getPhoto(item){
      if(item.photo){
        console.log('Warning harcoded url Users.getPhoto', item.photo)
        return item.photo
      }
    },
    setSearchText(search_text) {
      this.search=search_text
    },
    toggle_dialog() {
      this.showModalDialog = false
      this.modalTitle = ``
      this.fields_to_collect = []
      ;(this.submit_action = function () {}), (this.submit_button_caption = '')
      // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
    },

    get_user_centros(user) {
      // List of available centros for this user to set as preferred
      // Preferred centro should be one of the user's site centros
      return this.site_centros[user.site] || [];
    },

    user_actions(user,roles) {
      let items = {'modify_user': {}, 'change_roles': {}};
      items.modify_user.preferred_centro = this.get_user_centros(user).map((val) => [val.id, val.name]);
      items.change_roles.roles_items = (roles || [])//.map(it => [it.value,it.text]);
      items.change_roles.roles_value = this.user_roles(user.id);
      return User.get_manager_actions(user,items);
    },

    open_transition_modal(user,transition) {
      this.modal_title = `${transition.label} user`;
      //Deep copy
      this.fields_to_collect = JSON.parse(JSON.stringify(transition.layout));
      this.showModalDialog = true;
      this.submit_action = transition.object_submit == 'QCentro' ? this.update_user_roles : this.updateUser ;
      this.currentEditUser = user;
    },

    user_roles(user_id) {
      return [this.allRoles.filter(it => it.users.includes(user_id)).map(it => it.id)].flat();
     },


    update_user_roles(formdata) {
      const roles = formdata.get('roles');
      let set_roles = new Set();
      if (roles) {
        set_roles = new Set((roles).split(','));
      }
      QCentro.modify_user_roles(this.site_id, this.centro_id, this.currentEditUser.id, Array.from(set_roles)).then(()=>{
        this.showModalDialog = false;
        this.currentEditUser={};
        this.getRoles();
      });
    }
  },
 }
</script>


<style lang="scss">
  @import "@/sass/menus.scss";
</style>
